import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import InceptionPage from "@/pages/products/InceptionPage";

export const Route = createFileRoute("/products/agentic-enterprise-platform")({
  head: () => pageHead("Agentic Enterprise Platform | Agents-as-a-Service", "The Agentic Enterprise Platform delivers advanced reasoning and governed multi-agent collaboration, enabling complex multi-step analysis and enterprise-wide AI operations at scale.", "/products/agentic-enterprise-platform", false),
  component: InceptionPage,
});
